import { Action, ActionTypes, State } from './types';

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionTypes.SET_PERIOD_VALUE:
    case ActionTypes.SET_ACTIVE_CUSTOMER_SUPPLIER:
    case ActionTypes.SET_IS_OPEN_SIDE_PANEL:
    case ActionTypes.SET_DATA:
    case ActionTypes.SET_IS_LOADING:
    case ActionTypes.SET_IS_LOADING_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
